module.exports = __webpack_public_path__ + "static/media/dsp-loading.19a0e1b5.svg";